import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ToastDuration, ToastService } from '@shared';
import { Subscription } from 'rxjs';
import { ConnectionModalState, ConnectionsModalComponentsEnum, ConnectionTypeEnum } from '../../models';
import { ConnectionsModalState } from '../../services/connections-modal-state.service';

@Component({
	selector: 'app-connections-modal',
	templateUrl: 'modal.component.html',
	styleUrls: ['modal.component.scss']
})
export class ConnectionsModalComponent implements OnInit, OnDestroy {
	@Input() public connectionType: ConnectionTypeEnum;

	public activeComponent: ConnectionsModalComponentsEnum = ConnectionsModalComponentsEnum.listOfConnections;
	public connectionsModalComponentsEnum = ConnectionsModalComponentsEnum;
	public connectionId: string | null;
	public connectionsSubscription: Subscription;

	public constructor(
		private connectionsModalState: ConnectionsModalState,
		private modalCtrl: ModalController,
		private toastService: ToastService,
		private translateService: TranslateService
	) {}

	public ngOnInit(): void {
		this.connectionsSubscription = this.connectionsModalState.activeComponent$.subscribe(
			(modalState: ConnectionModalState) => {
				this.connectionId = modalState.connectionId;
				this.activeComponent = modalState.componentName;
			}
		);
	}

	public confirmAction(): void {
		if (this.activeComponent === ConnectionsModalComponentsEnum.editOptionsConnection) {
			this.toastService.presentSuccess(
				this.translateService.instant('connectionsModal.form.options.success.edit'),
				ToastDuration.Fast
			);

			this.connectionsModalState.setActive({
				componentName: ConnectionsModalComponentsEnum.listOfConnections,
				connectionId: this.connectionId
			});
		}

		if (this.connectionType === ConnectionTypeEnum.includeOptions) {
			this.modalCtrl.dismiss(this.connectionId);
		}
	}

	public close(): void {
		this.modalCtrl.dismiss(null);
	}

	public ngOnDestroy(): void {
		this.connectionsSubscription.unsubscribe();
	}
}
